import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceithene() {



  const cardData = {




keyword: "Cab Service in Thane",

headingDescription: "Garud Cab Service provides comfortable and reliable Cab Service in Thane for families, corporate travelers, tourists, senior citizens, students, and groups looking for convenient local and outstation transportation. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for local travel, airport transfers, railway station pickups, corporate transportation, sightseeing, one-way journeys, round trips, and customized outstation trips. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations across Thane, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes travel from Thane smooth and convenient. Travelers can also arrange private cabs for nearby cities, hill stations, pilgrimage destinations, coastal getaways, business locations, and long-distance routes according to their preferred schedule.",

topPlaces: [
  {
    title: "Malshej Ghat",
    description: "Malshej Ghat is a scenic destination in the Western Ghats known for misty mountains, waterfalls, green valleys, and beautiful monsoon landscapes. It is a popular weekend getaway for families and nature lovers traveling from Thane. Garud Cab Service provides comfortable private cabs with flexible one-way, round-trip, and sightseeing options."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a peaceful hill destination surrounded by Sahyadri mountains, forests, waterfalls, and scenic valleys. It is suitable for family vacations, weekend trips, and nature-focused journeys from Thane. Customers can book Sedan, SUV, Ertiga, Innova, or Innova Crysta with a professional chauffeur and customize their sightseeing route."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious, cultural, and business destination known for temples, riverfront areas, heritage attractions, and vineyards. Travelers from Thane can choose private cab transportation for pilgrimage, family visits, corporate travel, or sightseeing. Garud Cab Service offers comfortable vehicles with flexible pickup, drop, and return arrangements."
  },
  {
    title: "Shirdi",
    description: "Shirdi is a major pilgrimage destination visited by devotees throughout the year for Sai Baba darshan. Families and senior citizens from Thane can travel comfortably in a private chauffeur-driven cab without changing vehicles. Customers can select a suitable vehicle and arrange one-way, round-trip, or customized pilgrimage travel according to their schedule."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for viewpoints, valleys, lakes, waterfalls, strawberry farms, and pleasant mountain scenery. It is ideal for families and groups planning an extended road trip from Thane. Garud Cab Service provides spacious vehicles with comfortable seating and luggage capacity for multi-day sightseeing journeys."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill station surrounded by green valleys, waterfalls, lakes, and historic forts, making it suitable for weekend trips from Thane. Families, couples, and groups can enjoy a private cab journey with flexible sightseeing stops. Customers can book a one-way or round-trip vehicle based on their preferred travel plan."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal getaway known for beaches, forts, resorts, and peaceful seaside surroundings. Travelers from Thane can plan a family outing, weekend holiday, or short coastal trip with a private cab. Garud Cab Service provides chauffeur-driven vehicles with flexible pickup locations and customized sightseeing arrangements."
  },
  {
    title: "Pune",
    description: "Pune is a major business, educational, and technology destination frequently visited from Thane for corporate meetings, family travel, events, and personal work. Customers can book a direct private cab for convenient door-to-door transportation. Garud Cab Service offers suitable vehicles for individual travelers, families, and small groups with luggage."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a scenic destination surrounded by mountains, forests, lakes, and waterfalls and is suitable for peaceful weekend holidays. Families and nature lovers from Thane can enjoy a comfortable road journey with a private chauffeur-driven cab. Customers can customize their route to include nearby attractions and return according to their preferred schedule."
  },
  {
    title: "Dapoli",
    description: "Dapoli is a peaceful Konkan destination known for beaches, temples, greenery, and coastal landscapes. It is suitable for travelers looking for a longer family holiday away from the city. Garud Cab Service provides comfortable cabs from Thane with flexible multi-day, one-way, and round-trip booking options for convenient coastal travel."
  }
],





"services": [
{
"name": "Thane to Pune Cab",
"description": "Book Thane to Pune Cab for comfortable and convenient private transportation between Thane and Pune. The service is suitable for families, business travelers, tourists, students, and individuals looking for reliable intercity travel with professional chauffeurs."
},
{
"name": "Cab Booking in Thane",
"description": "Make Cab Booking in Thane for convenient local and outstation transportation with flexible pickup arrangements. Sedan, SUV, Innova, and premium vehicle options can be selected according to passenger count, luggage, travel schedule, and destination."
},
{
"name": "Car Rental in Thane for Outstation",
"description": "Choose Car Rental in Thane for Outstation travel when planning comfortable long-distance journeys from Thane. Chauffeur-driven cars can be arranged for family trips, business travel, sightseeing, religious tours, weekend holidays, and personal journeys."
},
{
"name": "Pune Thane Cab Service",
"description": "Book Pune Thane Cab Service for convenient private transportation between Pune and Thane with professional driver assistance. The service is suitable for corporate travelers, families, tourists, and passengers planning one-way or return intercity journeys."
},
{
"name": "Pune to Thane Taxi Fare",
"description": "Check Pune to Thane Taxi Fare according to the selected vehicle, pickup location, journey type, and travel requirements. Sedan, SUV, Innova, and premium options can be arranged for comfortable transportation between the two cities."
},
{
"name": "Cab Service in Thane",
"description": "Choose Cab Service in Thane for convenient local and outstation transportation with comfortable AC vehicles and professional chauffeurs. The service can be arranged for airport transfers, business travel, family trips, sightseeing, and intercity journeys."
},
{
"name": "Taxi Service in Thane",
"description": "Book Taxi Service in Thane for comfortable private transportation with convenient pickup and destination drop options. Suitable vehicles can be arranged for individuals, families, corporate passengers, tourists, and customers requiring local or long-distance travel."
},
{
"name": "Cabs in Thane",
"description": "Find Cabs in Thane for local transportation, airport transfers, and outstation journeys. Sedan, SUV, Innova, and larger vehicle options are available for passengers looking for practical and comfortable travel with professional driver assistance."
},
{
"name": "Taxi in Thane",
"description": "Book a Taxi in Thane for convenient point-to-point transportation across the city and nearby destinations. The service is suitable for daily travel, business appointments, airport transfers, family requirements, sightseeing, and outstation journeys."
},
{
"name": "Thane Cab Service",
"description": "Choose Thane Cab Service for reliable chauffeur-driven transportation with flexible pickup arrangements. Customers can select suitable vehicles for local trips, airport travel, corporate requirements, family journeys, sightseeing, and long-distance transportation."
},
{
"name": "Thane Taxi Service",
"description": "Book Thane Taxi Service for comfortable and convenient transportation within Thane and to nearby cities. Professional drivers and suitable vehicle categories make the service practical for families, business travelers, tourists, and individuals."
},
{
"name": "Car Rental in Thane",
"description": "Choose Car Rental in Thane for flexible transportation requirements with suitable vehicle options. Cars can be arranged for local travel, outstation journeys, airport transfers, business trips, family vacations, sightseeing, and personal travel."
},
{
"name": "Cab Booking in Thane",
"description": "Make Cab Booking in Thane for scheduled transportation with convenient pickup and vehicle selection. Sedan, SUV, Innova, and premium cars can be arranged according to passenger requirements, luggage, destination, and travel schedule."
},
{
"name": "Taxi Booking Thane",
"description": "Book Taxi Booking Thane services for convenient private transportation with professional chauffeur assistance. The service is suitable for local travel, airport transfers, business trips, family journeys, sightseeing, and outstation travel."
},
{
"name": "Best Cab Service in Thane",
"description": "Choose the Best Cab Service in Thane for comfortable private transportation supported by professional chauffeurs and well-maintained vehicles. The service is suitable for airport transfers, corporate travel, family trips, sightseeing, and outstation journeys."
},
{
"name": "Cheap Cab Service in Thane",
"description": "Book Cheap Cab Service in Thane for economical private transportation while maintaining basic comfort and convenience. Practical sedan and other vehicle options can be arranged for local travel, airport transfers, family journeys, and outstation trips."
},
{
"name": "Affordable Taxi Service Thane",
"description": "Choose Affordable Taxi Service Thane for practical transportation suited to different travel requirements and budgets. Customers can arrange comfortable vehicles for local trips, airport transfers, business travel, family journeys, and intercity travel."
},
{
"name": "24x7 Cab Service in Thane",
"description": "Book 24x7 Cab Service in Thane for transportation requirements at different hours of the day and night. The service is suitable for airport transfers, urgent travel, business trips, outstation journeys, and passengers requiring flexible pickup arrangements."
},
{
"name": "Cab Service Near Me Thane",
"description": "Choose Cab Service Near Me in Thane for convenient pickup from your preferred location within the city. Suitable vehicles can be arranged for local travel, airport transfers, family trips, corporate requirements, sightseeing, and outstation transportation."
},
{
"name": "Airport Cab Service Thane",
"description": "Book Airport Cab Service Thane for convenient transportation to and from Mumbai airport terminals. Comfortable AC vehicles and professional chauffeurs can be arranged for individuals, families, corporate passengers, and travelers carrying luggage."
},
{
"name": "Outstation Cab Service Thane",
"description": "Choose Outstation Cab Service Thane for comfortable long-distance travel from Thane to destinations across Maharashtra and nearby states. The service is suitable for family vacations, business trips, sightseeing, religious tours, and personal journeys."
},
{
"name": "One Way Cab Thane",
"description": "Book One Way Cab Thane for direct point-to-point transportation without requiring a return booking. The service is suitable for relocation, business travel, family visits, airport transfers, personal trips, and passengers traveling to another city."
},
{
"name": "Round Trip Taxi Thane",
"description": "Choose Round Trip Taxi Thane for convenient transportation with return travel included in the journey plan. The service is suitable for family trips, business visits, sightseeing, religious journeys, and short stays at nearby destinations."
},
{
"name": "Corporate Cab Service Thane",
"description": "Book Corporate Cab Service Thane for professional transportation supporting meetings, office visits, client appointments, employee travel, and business journeys. Sedan, SUV, and premium vehicles can be arranged according to corporate travel requirements."
},
{
"name": "Wedding Cab Service Thane",
"description": "Choose Wedding Cab Service Thane for comfortable transportation of guests and family members during wedding-related events. Suitable sedan, SUV, premium cars, and larger vehicles can be arranged according to group size and travel requirements."
},
{
"name": "Thane to Mumbai Airport Cab",
"description": "Book Thane to Mumbai Airport Cab for convenient airport transportation with pickup from your preferred Thane location. The service is suitable for domestic and international travelers, families, corporate passengers, and customers carrying luggage."
},
{
"name": "Thane to Pune Cab",
"description": "Choose Thane to Pune Cab for comfortable private intercity travel with professional chauffeur assistance. The service is suitable for families, corporate travelers, tourists, students, and individuals planning one-way or round-trip journeys."
},
{
"name": "Thane to Nashik Cab",
"description": "Book Thane to Nashik Cab for convenient private transportation to Nashik with comfortable AC vehicles. The service is suitable for families, tourists, business travelers, religious visits, sightseeing trips, and personal journeys."
},
{
"name": "Thane to Lonavala Cab",
"description": "Choose Thane to Lonavala Cab for comfortable transportation to the popular hill station. The service is suitable for weekend trips, family holidays, couples, groups, sightseeing, resort stays, and private leisure travel."
},
{
"name": "Thane to Shirdi Cab",
"description": "Book Thane to Shirdi Cab for convenient private transportation for pilgrimage and religious travel. Comfortable vehicles can be arranged for families, senior passengers, devotees, and groups planning a visit to Shirdi."
},
{
"name": "Thane to Goa Cab",
"description": "Choose Thane to Goa Cab for comfortable long-distance road transportation with professional chauffeur assistance. The service is suitable for family vacations, groups, couples, business travelers, and passengers planning a private Goa road trip."
},
{
"name": "SUV Cab Service in Thane",
"description": "Book SUV Cab Service in Thane for spacious and comfortable transportation with additional seating and luggage capacity. SUVs are suitable for families, groups, corporate travelers, tourists, and passengers planning longer local or outstation journeys."
},
{
"name": "7 Seater Cab in Thane",
"description": "Choose 7 Seater Cab in Thane for convenient group transportation with practical passenger and luggage space. The service is suitable for families, friends, corporate groups, airport transfers, sightseeing, and outstation travel."
},
{
"name": "Innova Cab Service Thane",
"description": "Book Innova Cab Service Thane for spacious chauffeur-driven transportation suitable for families and small groups. The vehicle provides comfortable seating and luggage capacity for airport transfers, business trips, sightseeing, and long-distance journeys."
},
{
"name": "Innova Crysta on Rent in Thane",
"description": "Choose Innova Crysta on Rent in Thane for premium and spacious transportation with comfortable interiors and professional chauffeur service. It is suitable for families, executives, corporate passengers, tourists, airport transfers, and outstation travel."
},
{
"name": "Ertiga Cab in Thane",
"description": "Book Ertiga Cab in Thane for practical group transportation with comfortable seating and luggage capacity. The vehicle is suitable for families, small groups, airport transfers, local travel, sightseeing, and outstation journeys."
},
{
"name": "Kia Carens Cab Thane",
"description": "Choose Kia Carens Cab Thane for comfortable and spacious transportation suitable for families and small groups. The vehicle can be arranged for local travel, airport transfers, corporate journeys, sightseeing, and outstation trips."
},
{
"name": "Family Cab Service in Thane",
"description": "Book Family Cab Service in Thane for comfortable private transportation designed around family travel requirements. Suitable vehicles can accommodate passengers and luggage for airport transfers, vacations, sightseeing, religious trips, and outstation journeys."
}
],
"tableData": [
["Thane to Pune Cab", "Cab Booking in Thane"],
["Car Rental in Thane for Outstation", "Pune Thane Cab Service"],
["Pune to Thane Taxi Fare", "Cab Service in Thane"],
["Taxi Service in Thane", "Cabs in Thane"],
["Taxi in Thane", "Thane Cab Service"],
["Thane Taxi Service", "Car Rental in Thane"],
["Cab Booking in Thane", "Taxi Booking Thane"],
["Best Cab Service in Thane", "Cheap Cab Service in Thane"],
["Affordable Taxi Service Thane", "24x7 Cab Service in Thane"],
["Cab Service Near Me Thane", "Airport Cab Service Thane"],
["Outstation Cab Service Thane", "One Way Cab Thane"],
["Round Trip Taxi Thane", "Corporate Cab Service Thane"],
["Wedding Cab Service Thane", "Thane to Mumbai Airport Cab"],
["Thane to Pune Cab", "Thane to Nashik Cab"],
["Thane to Lonavala Cab", "Thane to Shirdi Cab"],
["Thane to Goa Cab", "SUV Cab Service in Thane"],
["7 Seater Cab in Thane", "Innova Cab Service Thane"],
["Innova Crysta on Rent in Thane", "Ertiga Cab in Thane"],
["Kia Carens Cab Thane", "Family Cab Service in Thane"]
]
,



whychoose: [
  {
    WhyChooseheading: "Cab Service in Thane for Convenient Local Travel",
    WhyChoosedescription: "A private cab provides a practical transportation option in Thane for daily travel, airport transfers, railway station drops, corporate visits, family outings, local sightseeing, and journeys to nearby or outstation destinations."
  },
  {
    WhyChooseheading: "Pickup from Your Preferred Thane Location",
    WhyChoosedescription: "Passengers can arrange pickup from their home, hotel, office, residential society, railway station area, business location, or another accessible point in Thane."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Different Requirements",
    WhyChoosedescription: "Families, couples, professionals, and groups can select a suitable vehicle according to passenger count, luggage requirements, trip duration, and preferred comfort level."
  },
  {
    WhyChooseheading: "Convenient Airport & Railway Transfers",
    WhyChoosedescription: "Private cabs can be arranged for travel to and from nearby airports and railway stations, providing direct transportation between your preferred pickup point and the required transport terminal."
  },
  {
    WhyChooseheading: "Useful for Corporate & Business Travel",
    WhyChoosedescription: "Professionals and companies can arrange cabs for office visits, client meetings, conferences, industrial areas, business appointments, and regular corporate transportation requirements in and around Thane."
  },
  {
    WhyChooseheading: "Suitable for Local Thane Sightseeing",
    WhyChoosedescription: "A private cab can be used for visiting attractions, shopping areas, hotels, restaurants, residential locations, business districts, and other planned destinations across Thane."
  },
  {
    WhyChooseheading: "One-Way & Outstation Cab Options",
    WhyChoosedescription: "Travellers can choose one-way or round-trip transportation from Thane to destinations such as Mumbai, Pune, Lonavala, Mahabaleshwar, Nashik, Surat, and other preferred cities."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Thane pickup location, destination, travel date, passenger count, luggage details, preferred vehicle, and local or outstation travel requirement with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Cab Service in Thane?",
    answer: "Yes, Garud Cab Service provides private cab services in Thane for local travel, airport transfers, railway station transportation, corporate trips, family outings, sightseeing, and outstation journeys."
  },
  {
    question: "Can I book a cab from anywhere in Thane?",
    answer: "Yes, pickup can be arranged from a preferred accessible location in Thane, including homes, hotels, offices, residential societies, railway station areas, and business locations."
  },
  {
    question: "Can I book a Thane cab for airport transfers?",
    answer: "Yes, private cabs can be arranged for airport pickup and drop requirements according to your preferred travel date and schedule."
  },
  {
    question: "Can I use the cab for local travel in Thane?",
    answer: "Yes, private cabs can be used for transportation between residential areas, offices, hotels, shopping destinations, railway stations, business locations, and other accessible places in Thane."
  },
  {
    question: "Does the service provide outstation cabs from Thane?",
    answer: "Yes, outstation cab arrangements can be planned from Thane for one-way and round-trip travel to destinations such as Mumbai, Pune, Lonavala, Mahabaleshwar, Nashik, Surat, and other cities."
  },
  {
    question: "Can corporate travellers book cabs in Thane?",
    answer: "Yes, business travellers and companies can arrange private cabs for meetings, office visits, client appointments, conferences, industrial travel, and other professional transportation needs."
  },
  {
    question: "Is the Thane cab service suitable for families?",
    answer: "Yes, families and groups can select a suitable vehicle according to passenger numbers, luggage requirements, and comfort preferences."
  },
  {
    question: "Can I carry luggage in the Thane cab?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger luggage requirements should be communicated during booking."
  },
  {
    question: "Can I book a one-way cab from Thane?",
    answer: "Yes, one-way cab service can be arranged for passengers travelling to their preferred destination without requiring the same vehicle for the return journey."
  },
  {
    question: "How can I book a Cab Service in Thane?",
    answer: "Share your Thane pickup location, destination, travel date, passenger details, luggage requirements, preferred vehicle, and local or outstation travel requirement with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Harshad More",
    feedback: "I needed a cab in Thane for multiple business appointments and arranged a private vehicle. The convenient pickup and direct travel between locations helped me manage my schedule comfortably.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priti Desai",
    feedback: "Our family booked a cab in Thane for local travel and a railway station transfer. The private vehicle was convenient for travelling together with our luggage.",
    rating: 5
  }
];








  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Thane",
  "image": "https://garudcabs.com/assets/images/cab-service-in-thane.webp",
  "description": "Book Cab Service in Thane with Garud Cab for safe, comfortable, and dependable local, airport, and outstation transportation. Get taxi, cab booking, and car rental services across Thane for Pune and Mumbai travel, business trips, family journeys, airport transfers, and long-distance routes. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles with convenient pickup and drop facilities, flexible one way and round trip options, and 24x7 booking support.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/cab-service-in-thane"
  }
};



  return (
    <div>

<Helmet>
  <title>Cab Service in Thane | Taxi, Car Rental & Booking | +91 9970007784</title>

  <meta
    name="description"
    content="Book Cab Service in Thane with Garud Cab for reliable local, airport, and outstation travel. Get taxi, car rental, one way, round trip, and Pune-Thane cab services with Sedan, Ertiga, SUV, Innova, and Innova Crysta."
  />

  <meta
    name="keywords"
    content="Thane to Pune Cab, Cab Booking in Thane, Car Rental in Thane for Outstation, Pune Thane Cab Service, Pune to Thane Taxi Fare, Cab Service in Thane, Taxi Service in Thane, Cabs in Thane, Taxi in Thane, Thane Cab Service, Thane Taxi Service, Car Rental in Thane, Cab Booking in Thane, Taxi Booking Thane, Best Cab Service in Thane, Cheap Cab Service in Thane, Affordable Taxi Service Thane, 24x7 Cab Service in Thane, Cab Service Near Me Thane, Airport Cab Thane"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/101.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceithene;